import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: string | number): Date | null {
    if (typeof value === 'number') {
      return new Date(value);
    }

    if (!value) {
      return null;
    }

    const str = value.trim();

    // Try to parse DD/MM/YYYY format (accepts /, -, or . as separator)
    const ddmmyyyyRegex = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/;
    const match = str.match(ddmmyyyyRegex);

    if (match) {
      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10) - 1; // Months are 0-indexed
      const year = parseInt(match[3], 10);

      // Validate date
      const date = new Date(year, month, day);
      if (
        date.getFullYear() === year &&
        date.getMonth() === month &&
        date.getDate() === day
      ) {
        return date;
      }
    }

    // Fallback to native parsing
    return super.parse(value);
  }

  override format(date: Date, _displayFormat: unknown): string {
    if (!this.isValid(date)) {
      return '';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
